import { queryOptions } from '@tanstack/react-query'
import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'
import {
  ApplicationFlagList,
  GetApplicationFlagList,
  getPaginatedTasks,
  PaginatedTasks,
} from './requests.ts'
import { TaskSortBy } from './requests'

const TaskQueryKeys = {
  list_all: ['tasks'],
  paginateTasks: (
    recordsPerPage: number,
    currentPage: number,
    search?: string | undefined,
    selectedFilter?: string,
    sort_by?: TaskSortBy,
    program_id?: number
  ) => [
    ...TaskQueryKeys.list_all,
    recordsPerPage,
    currentPage,
    search,
    selectedFilter,
    sort_by,
    program_id,
  ],
} as const

const ApplicationFlagListKeys = {
  list_all: () => ['application_flags'],
} as const

export class TaskQueries {
  static getPaginatedTasks(
    recordsPerPage: number,
    currentPage: number,
    search?: string | '',
    selectedFilter?: string,
    sort_by?: TaskSortBy,
    program_id?: number,
    options: CustomQueryOptions<PaginatedTasks> = {}
  ) {
    return queryOptions({
      queryKey: TaskQueryKeys.paginateTasks(
        recordsPerPage,
        currentPage,
        search,
        selectedFilter,
        sort_by,
        program_id
      ),
      queryFn: () =>
        getPaginatedTasks(
          currentPage,
          recordsPerPage,
          search,
          selectedFilter,
          sort_by,
          program_id
        ),
      ...options,
    })
  }
  static FetchApplicationFlags(
    options: CustomQueryOptions<ApplicationFlagList> = {}
  ) {
    return queryOptions({
      queryKey: ApplicationFlagListKeys.list_all(),
      queryFn: () => GetApplicationFlagList(),
      ...options,
    })
  }
}
